import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { forwardRef } from 'react';
import { StyleSheet, TextInput, View, } from 'react-native';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import styled from 'styled-components/native';
import { match } from 'ts-pattern';
import ArrowDownIcon from '@/assets/icon/ic_arrow_down.svg';
import ClearIcon from '@/assets/icon/ic_clear.svg';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
const Input = forwardRef(({ value, placeholder, state, onChangeText, onBlur, onPress, onSubmitEditing, returnKeyType, isClearable = false, }, ref) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const localRef = React.useRef(null);
    React.useImperativeHandle(ref, () => localRef.current);
    const isValid = state === undefined
        ? undefined
        : state === 'VALID' || state === 'PROGRESS';
    const handleFocus = () => setIsFocused(true);
    const handleBlur = (e) => {
        setIsFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    const handleClear = () => {
        var _a;
        onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText('');
        (_a = localRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const renderInput = (props) => (_jsx(TextInput, Object.assign({ ref: localRef, value: value, onChangeText: onChangeText, placeholder: placeholder, placeholderTextColor: color.gray50, onFocus: handleFocus, onBlur: handleBlur, onSubmitEditing: onSubmitEditing, returnKeyType: returnKeyType, editable: !onPress, style: styles.input }, props)));
    return (_jsx(InputContainer, { children: _jsx(InputWrapper, { isFocused: isFocused, isValid: isValid, children: onPress ? (_jsxs(SccTouchableOpacity, { elementName: "company_modal_input_dropdown", onPress: onPress, style: {
                    flex: 1,
                    flexDirection: 'row',
                    alignItems: 'center',
                    paddingRight: 11,
                }, children: [renderInput({
                        pointerEvents: 'none',
                    }), _jsx(ArrowDownIcon, { width: 20, height: 20 })] })) : (_jsxs(View, { style: {
                    flex: 1,
                    flexDirection: 'row',
                    alignItems: 'center',
                    paddingRight: 8,
                }, children: [renderInput(), isClearable && value && (_jsx(SccTouchableOpacity, { elementName: "company_modal_input_clear", hitSlop: 12, onPress: handleClear, children: _jsx(ClearIcon, { width: 20, height: 20 }) }))] })) }) }));
});
export default Input;
const styles = StyleSheet.create({
    input: {
        flex: 1,
        fontFamily: font.pretendardMedium,
        fontSize: 16,
        color: color.gray100,
        padding: 0,
    },
});
const InputContainer = styled.View `
  margin-bottom: 24px;
`;
const InputWrapper = styled.View `
  flex-direction: row;
  align-items: center;
  border-bottom-width: 1px;
  border-bottom-color: ${props => match(props.isFocused)
    .with(true, () => match(props.isValid)
    .with(undefined, () => color.gray20)
    .with(true, () => color.blue50)
    .with(false, () => color.red)
    .exhaustive())
    .otherwise(() => color.gray20)};
  padding-bottom: 8px;
  margin-bottom: 4px;
`;
